import PostLoginReportsV2 from './postLoginReportsV2'
export default PostLoginReportsV2
